import { useSelector, useDispatch } from 'react-redux';
import { RootState, selectSidebarOpenState } from '../store/store';
import { toggleOpen, setIsOpen, setIsHover, setSettings } from '../store/store';
import type { SidebarSettings } from '../store/store';

export const useSidebar = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector((state: RootState) => state.sidebar.isOpen);
  const isHover = useSelector((state: RootState) => state.sidebar.isHover);
  const settings = useSelector((state: RootState) => state.sidebar.settings);
  const openState = useSelector(selectSidebarOpenState);

  return {
    isOpen,
    isHover,
    settings,
    toggleOpen: () => dispatch(toggleOpen()),
    setIsOpen: (isOpen: boolean) => dispatch(setIsOpen(isOpen)),
    setIsHover: (isHover: boolean) => dispatch(setIsHover(isHover)),
    getOpenState: () => openState,
    setSettings: (settings: Partial<SidebarSettings>) => dispatch(setSettings(settings)),
  };
};
